import React from 'react'

function FinanceView() {
    return (
        <div>FinanceView</div>
    )
}

export default FinanceView